import React, { useRef, useState } from 'react'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import RichTextEditor from 'srcReact/components/common2/RichTextEditor'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import Spinner from 'srcReact/components/common2/Spinner'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { useTranslation } from 'react-i18next'

export default function PostInputArea({
  feedId,
  originMessageId,
  entity,
  placeholder,
  clearContent,
  handleChange,
  handleReturn,
  handleFiles,
  getFileError,
  handleSendMessage,
  handleInputError,
  containerCSS,
  loadingSendMessage,
  focusInput,
  sendButtonCSS,
  activeUsers,
  inputError,
  userToTag,
  mentionMenuOrientation,
  draftMessage,
  feedInFileModal
}) {
  const sendButtonRef = useRef(null)
  const { t } = useTranslation()
  const [focusedMode, setFocusedMode] = useState(false)

  const userTag =
    draftMessage &&
    draftMessage[feedId] &&
    draftMessage[feedId][originMessageId] &&
    draftMessage[feedId][originMessageId].message.length > 0
      ? null
      : draftMessage && draftMessage[originMessageId] && draftMessage[originMessageId].message.length > 0
      ? null
      : userToTag

  const value =
    draftMessage && draftMessage[feedId] && draftMessage[feedId][originMessageId]
      ? draftMessage[feedId][originMessageId].message
      : draftMessage && draftMessage[originMessageId]
      ? draftMessage[originMessageId].message
      : ''

  return (
    <div className={`${styles.container} ${containerCSS}`}>
      <div
        id={originMessageId}
        data-typeid={entity && entity.id}
        data-type={entity && entity.type}
        data-groupid={entity && entity.groupId}
        className={styles.editorContainer}>
        <RichTextEditor
          parentObjectId={originMessageId}
          showTextFormatter={false}
          showEmojiPicker={false}
          showFilePicker={false}
          showInlineToolbar={true}
          renderInlineSendButton={() => (
            <button
              aria-label={t('messenger.sendMessage')}
              type='button'
              // disabled={loadingSendMessage}
              // aria-label={loadingSendMessage ? t('messenger.sendMessageLoading') : t('messenger.sendMessage')}
              ref={sendButtonRef}
              className={`${styles.sendButton} ${sendButtonCSS}`}
              onClick={handleSendMessage}>
              {loadingSendMessage ? (
                <Spinner isWhite={true} />
              ) : (
                <Icon name='send-copy' styleModifier={styles.sendIcon} />
              )}
            </button>
          )}
          keepFormatOnPopulate={true}
          showToolbar={false}
          placeholder={placeholder}
          clearEditor={clearContent}
          handleChange={handleChange}
          handleReturn={handleReturn}
          handleFiles={handleFiles}
          allowedImageTypes={appConstantSettings.ACCEPTED_IMAGE_TYPES}
          allowedImageSizeInMB={appConstantSettings.MAX_IMAGE_SIZE_MB}
          allowedDocumentTypes={appConstantSettings.ACCEPTED_DOCUMENT_TYPES}
          allowedDocumentSizeInMB={appConstantSettings.MAX_DOC_SIZE_MB}
          filesLimit={appConstantSettings.FILES_LIMIT}
          getFileError={getFileError}
          containerCSS={styles.richTextAreaWrapper}
          charLimit={appConstantSettings.MAX_CHAR_COUNT}
          maxLines={appConstantSettings.MAX_LINES}
          handleInputError={handleInputError}
          editorId={`commentPost${originMessageId}`}
          errorMessageLimitExceed={t('messenger.clientErrors.longMessageError')}
          errorMessageRequired={t('messenger.clientErrors.emptyMessageError')}
          fromMessenger={false}
          focusInput={focusInput}
          activeUsers={activeUsers}
          mentionMenuOrientation={mentionMenuOrientation}
          userToTag={userTag}
          value={value}
          handleFocusMode={setFocusedMode}
          focusedMode={focusedMode}
        />
      </div>
      {inputError && inputError.length > 0 && <ErrorMessage text={inputError} className={styles.feedInputError} />}
    </div>
  )
}
